import { LogChannel, LoggingMessageInterface } from '@rx-applications/shared/logging';

export enum EventName {
  UserTokenNotValidForThisPortal = 'UserTokenNotValidForThisPortal',
}

export const LogChannelMessageMappings = {
  [EventName.UserTokenNotValidForThisPortal]: {
    channels: [LogChannel.Datadog],
    message: { name: 'User token not valid for this portal', type: 'action' } as LoggingMessageInterface,
  },
};
